import versionCheckerTemplate from './versionChecker.html';

/**
 * The browser should periodically check for newer versions of the application
 * and prompt a message to refresh the page when necessary.
 */
function versionChecker() {
    'use strict';

    return {
        restrict: 'E',
        scope: {},
        controller: ['$scope', '$http', function($scope, $http) {
            function isNewer(current, available) {
                var aCurrent = current.split('.').map((a) => parseInt(a, 10));
                var aAvailable = available.split('.').map((a) => parseInt(a, 10));
                for (var i = 0; i < current.length; i++) {
                    if (available[i] > current[i]) {
                        return true;
                    }
                }
                return false;
            }
            function checkForUpdates() {
                if ($scope.hasSeenAlert) {
                    return;
                }
                $http.get('/version')
                    .then(function(res) {
                        $scope.latestVersion = res.data;
                        $scope.newVersionAvailable =
                                isNewer($scope.currentVersion, $scope.latestVersion);
                    });
                setTimeout(checkForUpdates, 600000 /* 10 min */);
            }
            $scope.currentVersion = process.env.VERSION;
            $scope.dismissAlert = function(){
                $scope.hasSeenAlert = true;
            }
            checkForUpdates();
        }],
        template: versionCheckerTemplate
    };
}

versionChecker.$inject = [];

export default versionChecker;



// WEBPACK FOOTER //
// ./js/version/versionChecker.js